/**
 * Utility functions for user country verification and sorting.
 */

/**
 * Checks if a user profile country value is missing, empty, or invalid ('N/A', '0', null, etc.).
 * @param {string|number|null|undefined} country
 * @returns {boolean}
 */
export const isCountryMissing = (country) => {
  if (country === null || country === undefined) return true;
  const str = String(country).trim().toLowerCase();
  return str === "" || str === "0" || str === "n/a" || str === "null" || str === "undefined";
};

/**
 * Sorts countries with Nigeria and North America (US, Canada) prioritized at the top,
 * followed by remaining countries sorted alphabetically by name.
 * @param {Array} countries
 * @returns {Array}
 */
export const sortCountriesWithPriority = (countries = []) => {
  if (!Array.isArray(countries) || countries.length === 0) return [];

  const isNigeria = (c) =>
    String(c?.id) === "160" || (c?.name && c.name.toLowerCase() === "nigeria");

  const isUS = (c) =>
    c?.name &&
    (c.name.toLowerCase() === "united states" ||
      c.name.toLowerCase() === "united states of america" ||
      c.name.toLowerCase() === "usa");

  const isCanada = (c) =>
    c?.name && c.name.toLowerCase() === "canada";

  const nigeria = countries.filter(isNigeria);
  const us = countries.filter(isUS);
  const canada = countries.filter(isCanada);

  const priorityIds = new Set(
    [...nigeria, ...us, ...canada].map((c) => String(c?.id))
  );

  const others = countries
    .filter((c) => !priorityIds.has(String(c?.id)))
    .sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));

  return [...nigeria, ...us, ...canada, ...others];
};
